import React from 'react';
import './Footer.css';

interface FooterProps {
  darkMode: boolean;
}

const Footer: React.FC<FooterProps> = ({ darkMode }) => {
  return (
    <footer className={`app-footer ${darkMode ? 'dark' : ''}`}>
      <div className="footer-content">
        <div className="footer-section company-info">
          <h3>Jobometry Ltd</h3>
          <address>
            71-75 Shelton St<br />
            London WC2H 9JQ<br />
            United Kingdom
          </address>
        </div>
        
        <div className="footer-section links">
          <h4>Company</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/careers">Careers</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        
        <div className="footer-section legal">
          <h4>Legal</h4>
          <ul>
            <li><a href="/terms.html">Terms of Service</a></li>
            <li><a href="/privacy.html">Privacy Policy</a></li>
            <li><a href="/cookies">Cookie Policy</a></li>
          </ul>
        </div>
        
        <div className="footer-section social">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://linkedin.com/company/jobometry" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><a href="https://twitter.com/jobometry" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="mailto:sales@jobometry.io">Email Us</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Jobometry Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;